import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Establishment } from "../../../interfaces";
import { BsModalService } from "ngx-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToasterService } from "../../../services/toaster.service";
import { AuthService } from "../../../services/auth.service";
import { UserService } from "../../../services/user.service";
import { Router } from "@angular/router";
import { GTMService } from "src/app/services/gtm.service";

@Component({
  selector: "ng-tickets-modal",
  styleUrls: ["./modal.component.scss"],
  providers: [BsModalService],
  template: `
    <!-- Button to buy tickets if establishment.group is 'checkout' -->
      <button
        *ngIf="establishment.group === 'checkout'"
        class="btn"
        (click)="handleButtonClick()"
        [disabled]="loading"
      >
        <i aria-hidden="true" class="fa fa-ticket" *ngIf="!loading"></i>
        <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
        COMPRAR
      </button>


    <!-- Coupon generate button if establishment.group is not 'checkout' and no coupon exists -->
    <footer
      class="text-center"
      *ngIf="
        establishment.group !== 'checkout' && establishment.group == 'coupon'
      "
    >
      <button class="btn" (click)="generateCoupon()">
        <i class="fa fa-ticket" aria-hidden="true"></i> Gerar cupom
      </button>
    </footer>

    <!-- Display the generated coupon if it exists and establishment.group is not 'checkout' -->
    <span
      class="bar-space"
      *ngIf="
        establishment.group !== 'checkout' &&
        !partnership?.site &&
        coupon != null
      "
    ></span>
    <div
      class="coupon-wrapper"
      *ngIf="
        establishment.group !== 'checkout' &&
        !partnership?.site &&
        coupon != null
      "
    >
      <p><i class="fa fa-ticket" aria-hidden="true"></i> {{ coupon }}</p>
    </div>

    <!-- Link to partnership site if applicable and establishment.group is not 'checkout' -->
    <footer
      class="text-center"
      *ngIf="establishment.group !== 'checkout' && partnership?.site"
    >
      <a target="_blank" [href]="'http://' + partnership.site" class="btn">
        <i class="fa fa-ticket" aria-hidden="true"></i>Visitar site
      </a>
    </footer>

    <!-- Modals -->
    <ng-core-modal #modalApp>
      <div class="flex">
        <div class="block">
          <h3 class="title">
            Ops! Parece que você está tentando comprar ingressos pelo navegador!
          </h3>
          <p class="description">
            A partir de agora, para oferecer uma experiência ainda melhor e mais
            personalizada, a compra de ingressos de cinema está disponível
            exclusivamente no nosso aplicativo.
          </p>
          <p class="description">
            <a href="https://allyaapp.page.link/tag-checkout" class="link"
              >Clique aqui</a
            >
            ou acesse o QR code para acessar o app.
          </p>
          <p class="description">
            Para mais informações acesse nossa
            <a class="link" href="https://ajuda.allya.com.br/pt-BR/"
              >Central de Ajuda!</a
            >
          </p>
        </div>
        <div class="block-image">
          <img src="assets/shared/img/qr-code.png" />
          <div class="aux-image">
            <a
              href="https://play.google.com/store/apps/details?id=com.allyaapp&hl=pt_BR&gl=US&pli=1"
            >
              <img src="assets/shared/img/google-play.png" />
            </a>
            <a href="https://apps.apple.com/br/app/allya/id1398933563">
              <img src="assets/shared/img/apple-app.png" />
            </a>
          </div>
        </div>
      </div>
    </ng-core-modal>

    <ng-core-modal #modalRegister [config]="modalConfig" class="modal-cpf">
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <p class="description-modal">
          Antes de continuar, por favor, insira seu CPF. Isso nos ajuda a
          garantir uma experiência tranquila e segura para você.
        </p>
        <div class="form-group">
          <input
            type="text"
            id="cpf"
            placeholder="CPF"
            formControlName="cpf"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.cpf.errors }"
            (input)="onInput($event)"
            maxlength="14"
          />
          <div *ngIf="submitted && f.cpf.errors" class="invalid-feedback">
            <div class="error-text" *ngIf="f.cpf.errors.required">
              CPF é obrigatório
            </div>
            <div class="error-text" *ngIf="f.cpf.errors.pattern">
              CPF inválido
            </div>
          </div>
        </div>
        <div class="buttons">
          <button type="button" class="btn-cancelar" (click)="onCancel()">
            Cancelar
          </button>
          <button type="submit" class="btn-cadastrar">Cadastrar</button>
        </div>
      </form>
    </ng-core-modal>
  `,
})
export class TicketsModalComponent implements OnInit {
  @Input() title = "COMPRAR";
  @Input() establishment: Establishment;
  @Input() partnership: any;

  @ViewChild("modalRegister") modalRegister: any;

  modalConfig = { ignoreBackdropClick: false };
  registerForm: FormGroup;
  submitted = false;
  establishmentId: any;
  coupon: string;
  request: any;
  loading: boolean = false;

  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private toastrService: ToasterService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private gtm: GTMService
  ) {}

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      cpf: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/),
        ],
      ],
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  onInput(event: any) {
    let value = event.target.value.replace(/\D/g, "");
    value = value.replace(/^(\d{3})(\d)/, "$1.$2");
    value = value.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1-$2");
    event.target.value = value;
  }

  onSubmit() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    const cpf = this.registerForm.value.cpf;
    const dataToUpdate = { cpf: cpf };

    this.authService.updateMe(dataToUpdate).subscribe(
      (user) => {
        this.toastrService.success(
          'Sucesso!',
          'Cadastro atualizado com sucesso.'
        );
        this.sendTrackEvent('cadastrar', cpf);
        this.redirectToCheckout();
      },
      (err) => {
        this.toastrService.error('Erro!', err.error.message);
      }
    );
  }

  onCancel() {
    const cpf = this.registerForm.value.cpf
      ? this.registerForm.value.cpf.replace(/\D/g, "")
      : "";
    this.sendTrackEvent("cadastrar", cpf);
    this.modalRegister.closeModal();
  }

  sendTrackEvent(actionSuffix: string, cpf: string) {
    const urlParts = window.location.href.split("/");
    const partnerName = urlParts[urlParts.length - 1];

    const eventContent = {
      category: "portal",
      action: `${partnerName}:click`,
      label: `${cpf}:${actionSuffix}`,
    };

    this.gtm.sendEvent(eventContent);
  }

  handleButtonClick() {
    this.loading = true; // Ativar o loading
    const user = this.userService.getLoggedUser();
    const loggedAccount = this.userService.getLoggedAccount();
    this.establishmentId = loggedAccount.id;
  
    const urlParts = window.location.href.split("/");
    const partnerName = urlParts[urlParts.length - 1];
  
    const eventContent = {
      category: "portal",
      action: `${partnerName}:click`,
      label: "comprar",
    };
  
    this.gtm.sendEvent(eventContent);
  
    if (user.cpf) {
      this.redirectToCheckout();
    } else {
      this.modalRegister.openModal();
      this.loading = false; // Desativar o loading se o modal for aberto
    }
  }
  
  redirectToCheckout() {
    setTimeout(() => {
      window.location.href = `/checkout?establishmentId=${this.establishment.id}`;
      this.loading = false; // Desativar o loading após o redirecionamento
    }, 3000);
  }
  

  public generateCoupon(): void {
    const user = <any>this.userService.getLoggedUser();
    const obj: any = {
      type: "partnership",
      establishmentId: this.partnership.id,
      customerId: user.customerId,
      companyId: this.userService.getLoggedAccount().id,
    };

    this.request
      .post("coupons", obj, "", "/generate")
      .then((response) => {
        this.coupon = response.code;
      })
      .catch((err) => {
        if (err.status === 422) {
          this.toastrService.error(
            "Erro",
            "Não foi possível gerar o cupom. Por favor, tente novamente mais tarde.",
            true,
            4000
          );
        } else {
          this.toastrService.error(
            "Erro",
            "Ocorreu um erro inesperado. Por favor, tente novamente.",
            true,
            4000
          );
        }
      });
  }
}
